// Updated plugin to handle flow resumption and completed flows
export default defineNuxtPlugin({
  name: 'subscribe-protection-client',
  enforce: 'pre', // Run before other plugins
  setup() {
    const route = useRoute()

    // Only run on client-side
    if (import.meta.client) {
      // Check if we're on a subscription entry point
      if (
        route.path.includes('/subscribe/details') ||
        route.path === '/subscribe'
      ) {
        const email = route.query.email as string

        // No email in query params? Redirect to home
        if (!email) {
          console.log('No email in query params, redirecting to home')

          // When redirecting to home, preserve the flow_resumed parameter
          const hasFlowResumed = route.query.flow_resumed === 'true'
          const query = hasFlowResumed ? '?flow_resumed=true' : ''
          window.location.href = '/' + query
          return
        }

        // Check if this is a flow resumption
        const isResumingFlow = route.query.flow_resumed === 'true'

        // If we're resuming a flow, allow it to continue
        if (isResumingFlow) {
          console.log('Resuming flow for email:', email)
          return
        }

        // Check if this user has already completed the flow
        const hasCompletedFlow =
          localStorage.getItem(`subscription_completed_${email}`) === 'true'

        if (hasCompletedFlow) {
          console.log(
            'User has already completed the subscription flow, redirecting to home',
          )
          window.location.href = '/'
          return
        }

        // If we get this far, this is a valid visit
        console.log('Valid subscription entry point')
      }
    }
  },
})
